import React from 'react';
import './App.css';
import {Canvas} from "./components/canvas";
import 'antd/dist/antd.css';

function App() {
    return (
        <Canvas/>
    );
}

export default App;
